import { clsx } from "clsx";
import { ReactNode } from "react";
import styles from "./PlaybackControls.module.css";

type PlaybackControlsProps = Omit<React.HTMLProps<HTMLDivElement>, "className"> & {
  children: ReactNode;
  /** Variant styling lives in the parent's CSS Module (was the previous `innerSx` prop). */
  className?: string;
};

export default function PlaybackControls({ children, className, ...props }: PlaybackControlsProps) {
  return (
    <div {...props} className={clsx(styles.controls, className)}>
      {children}
    </div>
  );
}
